import { Box, Typography, Link, Accordion } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Link as RouterLink } from 'react-router-dom'
import SupportAgentIcon from '@mui/icons-material/SupportAgent'

export const PageWrapper = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(6),
  paddingBottom: theme.spacing(8),
}))

export const HeroSection = styled(Box)(({ theme }) => ({
  textAlign: 'center',
  marginBottom: theme.spacing(8),
}))

export const Logo = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(2),
  marginBottom: theme.spacing(3),
}))

export const LogoIcon = styled(SupportAgentIcon)(({ theme }) => ({
  fontSize: 48,
  color: theme.palette.brand.main,
  display: 'block',
  [theme.breakpoints.down('md')]: {
    fontSize: 38,
  },
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontSize: 42,
  fontWeight: 700,
  lineHeight: 1,
  color: theme.palette.text.primary,
  [theme.breakpoints.down('md')]: {
    fontSize: 32,
  },
}))

export const Tagline = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  color: theme.palette.text.secondary,
  maxWidth: 600,
  margin: '0 auto',
  lineHeight: 1.6,
  [theme.breakpoints.down('md')]: {
    fontSize: 16,
  },
}))

export const Section = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(6),
}))

export const SectionTitle = styled(Typography)(({ theme }) => ({
  fontSize: 24,
  fontWeight: 600,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(3),
  textAlign: 'center',
  [theme.breakpoints.down('md')]: {
    fontSize: 20,
  },
}))

export const ContactCard = styled(Box)(({ theme }) => ({
  maxWidth: 640,
  margin: '0 auto',
  padding: theme.spacing(4),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: theme.palette.background.paper,
  textAlign: 'center',
}))

export const ContactIcon = styled(Box)(({ theme }) => ({
  width: 56,
  height: 56,
  borderRadius: 14,
  backgroundColor: theme.palette.brand.main + '20',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  margin: '0 auto',
  marginBottom: theme.spacing(2),
  '& svg': {
    fontSize: 28,
    color: theme.palette.brand.main,
  },
}))

export const ContactEmail = styled(Link)(({ theme }) => ({
  display: 'inline-block',
  fontSize: 22,
  fontWeight: 600,
  color: theme.palette.brand.main,
  marginBottom: theme.spacing(1),
  [theme.breakpoints.down('md')]: {
    fontSize: 18,
  },
}))

export const ContactNote = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.secondary,
  lineHeight: 1.7,
  maxWidth: 480,
  margin: '0 auto',
  marginTop: theme.spacing(1),
}))

export const ReportRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'center',
  gap: theme.spacing(1),
  marginTop: theme.spacing(3),
  maxWidth: 520,
  marginLeft: 'auto',
  marginRight: 'auto',
  textAlign: 'left',
  color: theme.palette.text.secondary,
  fontSize: 14,
  lineHeight: 1.5,
  '& svg': {
    fontSize: 20,
    color: theme.palette.brand.main,
    flexShrink: 0,
    marginTop: 2,
  },
}))

export const FaqWrapper = styled(Box)({
  maxWidth: 760,
  margin: '0 auto',
})

export const FaqAccordion = styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: Number(theme.shape.borderRadius),
  marginBottom: theme.spacing(1.5),
  boxShadow: 'none',
  '&:before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 0,
    marginBottom: theme.spacing(1.5),
  },
}))

export const FaqQuestion = styled(Typography)(({ theme }) => ({
  fontSize: 15,
  fontWeight: 600,
  color: theme.palette.text.primary,
}))

export const FaqAnswer = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  color: theme.palette.text.secondary,
  lineHeight: 1.7,
}))

export const ClosingText = styled(Typography)(({ theme }) => ({
  fontSize: 15,
  color: theme.palette.text.secondary,
  lineHeight: 1.8,
  maxWidth: 640,
  textAlign: 'center',
  margin: '0 auto',
}))

export const InlineLink = styled(RouterLink)(({ theme }) => ({
  color: theme.palette.brand.main,
}))
